import { useCallback, useEffect, useState } from "react";

// UX-ONBOARD-01: auto-show rule lives entirely client-side against the backend's `login_count`
// (incremented server-side on every successful login — see auth_routes.py/member_auth.py) —
// auto-opens once per NEW login while `login_count <= 4`, never again after that (only the
// floating help icon can re-open it from then on). `localStorage` (not sessionStorage) so a
// page refresh mid-session never re-triggers it, keyed per-user so switching accounts on the
// same browser doesn't leak one user's "already seen" state into another's.
export function useOnboardingTour(persona, loginCount, userId) {
  const [isOpen, setIsOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    if (!userId || loginCount == null || loginCount > 4) return;
    const key = `ff_onboarding_tour_seen_${persona}_${userId}`;
    const lastShownFor = localStorage.getItem(key);
    if (String(loginCount) === lastShownFor) return;
    localStorage.setItem(key, String(loginCount));
    setStepIndex(0);
    setIsOpen(true);
  }, [persona, loginCount, userId]);

  const close = useCallback(() => setIsOpen(false), []);
  const restart = useCallback(() => { setStepIndex(0); setIsOpen(true); }, []);
  const goTo = useCallback((index, totalSteps) => {
    if (index >= totalSteps) { setIsOpen(false); return; }
    setStepIndex(index);
  }, []);

  return { isOpen, stepIndex, close, restart, goTo };
}
